// extracted by mini-css-extract-plugin
module.exports = {"userProfile":"styles_userProfile__1SzqL"};